import { useState } from "react";
import s from "../clinic.module.css";
import { Button, FormSection } from "../../ui";
import TrainerAssignmentsFields from "../AdminTeam/TrainerAssignmentsFields";
import { useTrainerGroupToggle } from "./useTrainerGroupToggle";
import { TrainerGroupRemoveDialog } from "./TrainerGroupRemoveDialog";

export default function AdminDoctorBranchesForm({
  groups = [],
  groupIds = [],
  onChangeAssignments,
  onSave,
}) {
  const [saving, setSaving] = useState(false);
  const { toggleGroup, pendingRemove, confirmRemove, cancelRemove } =
    useTrainerGroupToggle({
      groups,
      groupIds,
      onChangeAssignments,
    });

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave?.();
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {groups.length > 0 && onChangeAssignments ? (
        <FormSection
          title="Группы"
          description="Назначьте тренера на группу — он станет ведущим всех её занятий. Снимите галочку — занятия перейдут к владельцу. Точечно по дням — во вкладке «Слоты» или в расписании группы."
        >
          <TrainerAssignmentsFields
            groupsOnly
            groups={groups}
            groupIds={groupIds}
            onToggleGroup={toggleGroup}
          />
        </FormSection>
      ) : (
        <p className={s.attachmentHint}>Сначала создайте группу в разделе «Группы».</p>
      )}

      <Button
        type="button"
        style={{ marginTop: 16 }}
        disabled={saving}
        onClick={handleSave}
      >
        {saving ? "Сохранение…" : "Сохранить"}
      </Button>

      <TrainerGroupRemoveDialog
        open={Boolean(pendingRemove)}
        groupName={pendingRemove?.name || "группа"}
        onConfirm={confirmRemove}
        onCancel={cancelRemove}
      />
    </>
  );
}
